/** Default $5 / dog (cents) when sharing kennels on Signature Stay. */
export const DEFAULT_COMFORT_UPGRADE_SHARING_DISCOUNT = 500

export const getComfortUpgradeSharingDiscount = (boardingServices = {}) => {
	const fromFacility = Number(boardingServices.comfort_upgrade_sharing_discount)
	return Number.isFinite(fromFacility)
		? fromFacility
		: DEFAULT_COMFORT_UPGRADE_SHARING_DISCOUNT
}

export const getComfortPlusOvernightRate = (boardingServices = {}) => {
	return (
		boardingServices.comfort_plus_overnights_price ||
		boardingServices.overnights_price ||
		5000
	)
}

/** Shared Signature Stay unit rate (cents / dog / night) after sharing discount. */
export const getSharedComfortPlusOvernightRate = (boardingServices = {}) => {
	const comfortPlusRate = getComfortPlusOvernightRate(boardingServices)
	const discount = getComfortUpgradeSharingDiscount(boardingServices)
	return Math.max(0, comfortPlusRate - discount)
}

/**
 * Pairing counts for shared kennels (max 2 dogs per kennel).
 * Odd dog stays solo at full price.
 */
export const getSharedKennelDogCounts = (numberOfPets) => {
	const oddDogs = numberOfPets % 2
	const pairedDogs = numberOfPets - oddDogs
	const sharedKennels = Math.floor(numberOfPets / 2)
	return { oddDogs, pairedDogs, sharedKennels }
}
